export const PXFst = (function () {
  'use strict'

  let fstPackages, fstResponses

  function init() {
    if (typeof fst === 'undefined' || !document.getElementById('fst')) return
    fstPackages = fst.packages
    fstResponses = fst.responses
    events()
  }

  function ceiling(x) {
    const int = parseInt(x)
    if (x - int <= 0.5) {
      if (x - int === 0) return int
      return int + 0.5
    } else return int + 1
  }

  function events() {
    jQuery('#fst').submit(function (event) {
      // Prevent form from triggering reload
      event.preventDefault()
      let packageType = jQuery('#lube-package').val()
      run_calculations(packageType)
    })

    jQuery('#lube-package').change(function (ev) {
      ev.preventDefault()

      run_calculations(jQuery(this).val())
    })

    // Set associated package on conduit radio click
    jQuery('#lube-size').change(function () {
      if (jQuery(this).val() < 2) jQuery('#lube-package').val('FST-MINI')
      else jQuery('#lube-package').val('FST-250KIT')

      let packageType = jQuery('#lube-package').val()

      run_calculations(packageType)
    })

    // Clear conduit number and form responses on clear button click
    jQuery('#clear-fst').click(() => {
      jQuery('#conduit-number').val('')
      jQuery('#lube-size').val('.5')
      jQuery('#lube-package').val('FST-MINI')
      jQuery('#fst-message').html(
        `<li><p id="fst-error-message" class="calculator__paragraph">${fstResponses.no_calculations}</p></li>`
      )
    })
  }

  function run_calculations(packageType = null) {
    // Get form data
    const data = jQuery('#fst').serializeArray()
    const number = parseInt(data[2].value)
    let message = ''

    // Set error message if error
    if (data[0].value === undefined)
      message = `<li><p id="fst-error-message" class="calculator__paragraph">${fstResponses.pick_size}</p></li>`
    else {
      if (!Number.isInteger(number))
        message = `<li><p id="fst-error-message" class="calculator__paragraph">${fstResponses.integer}</p></li>`
      else if (number < 1 || number > 1000)
        message = `<li><p id="fst-error-message" class="calculator__paragraph">${fstResponses.bounds}</p></li>`
    }

    //  If no errors
    if (message === '') {
      // FST-MINI constants
      let h = 2
      let sf = 1.4
      let partial = 0.0826
      let x = 20
      let pkgString = fstPackages.mini
      let unit = fstResponses.squirt

      // FST-250KIT constants
      if (data[0].value > 1.5) {
        h = 3
        sf = 1.75
        partial = 0.9313
        x = 8.6
        pkgString = fstPackages.kit_250
        unit = 'cm'
      }

      if (packageType !== null) {
        if (packageType === 'FST-MINI') {
          h = 2
          sf = 1.4
          partial = 0.0826
          x = 20
          pkgString = fstPackages.mini
          unit = fstResponses.squirt
        } else {
          h = 3
          sf = 1.75
          partial = 0.9313
          x = 8.6
          pkgString = fstPackages.kit_250
          unit = 'cm'
        }
      }

      // Main calculations
      const size = data[0].value
      const volumeFill = h * 3.14159 * Math.pow(size / 2, 2)
      const quantity = volumeFill * 7.3 * Math.pow(1 / 12, 3) * 16 * sf
      let use0 = ceiling(quantity / partial)
      let use20 = ceiling((quantity / partial) * 0.8)

      const total0 = parseInt((use0 / x) * number) + 1
      const total20 = parseInt((use20 / x) * number) + 1

      if (unit === fstResponses.squirt) {
        use0 = Math.ceil(use0)
        use20 = Math.ceil(use20)
      }

      // Create response message
      message = `<li><p class="calculator__message-heading">${fstResponses.conduit_requires} ${use20} ${unit}${fstResponses.plural}.</p>
	  <p class="calculator__paragraph">${fstResponses.job_requires} <strong>${total20}</strong> ${pkgString}${fstResponses.plural}. (${fstResponses.based} <strong>20%</strong> ${fstResponses.cable})</p></li>

				<li><p class="calculator__message-heading">${fstResponses.conduit_requires} ${use0} ${unit}${fstResponses.plural}.</p>
				<p class="calculator__paragraph">${fstResponses.job_requires} <strong>${total0}</strong> ${pkgString}${fstResponses.plural}. (${fstResponses.based} <strong>0%</strong> ${fstResponses.cable})</p></li>`
    }

    // if there are errors
    else {
      jQuery('#conduit-number').focus()
    }

    // Set response/error message
    jQuery('#fst-message').html(message)
  }

  return { init }
})()
